import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import lawyer from '../../assets/images/lawyer1.jpg';

const AboutSection = () => {
    const highlights = [
        'Over 20 years of legal excellence',
        'High success rate in complex cases',
        'Dedicated team of expert lawyers',
        'Personalized legal solutions',
    ];

    return (
        <section className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    {/* Image Section */}
                    <div className="relative order-2 lg:order-1">
                        <div className="absolute -top-6 -left-6 right-6 bottom-6 bg-indigo-50 rounded-lg -z-10"></div>
                        <img 
                            src={lawyer}
                            alt="Legal Team" 
                            className="rounded-lg shadow-lg w-full object-cover h-full max-h-[600px]"
                        />
                        <div className="absolute bottom-8 right-0 bg-indigo-600 text-white p-6 rounded-l-lg shadow-xl transform translate-x-0 transition-transform duration-300 hover:translate-x-2">
                            <div className="text-4xl font-bold">20+</div>
                            <div className="text-sm font-medium">Years of Experience</div>
                        </div>
                    </div>

                    {/* Content Section */}
                    <div className="order-1 lg:order-2">
                        <div className="inline-block bg-indigo-100 text-indigo-800 px-4 py-1 rounded-md text-sm font-medium mb-4">
                            ABOUT OUR FIRM
                        </div>
                        <h2 className="text-4xl font-bold mb-6 text-gray-800">
                            Leading Law Firm with a <span className="text-indigo-600">Winning Track Record</span>
                        </h2>
                        <p className="text-gray-600 mb-8 text-lg leading-relaxed">
                            With over two decades of experience, we've established ourselves as a 
                            trusted name in legal services. Our commitment to excellence and 
                            client satisfaction sets us apart in the legal industry.
                        </p>

                        <div className="space-y-5 mb-10">
                            {highlights.map((item, index) => (
                                <div key={index} className="flex items-center bg-gray-50 p-4 rounded-lg shadow-sm transition-all duration-300 hover:shadow-md transform hover:-translate-y-1">
                                    <CheckCircle className="text-indigo-600 w-6 h-6 mr-4 flex-shrink-0" />
                                    <span className="text-gray-700 font-medium">{item}</span>
                                </div>
                            ))}
                        </div>

                        <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-4 rounded-md flex items-center font-medium transition-all shadow-md hover:shadow-lg">
                            Learn More About Us
                            <ArrowRight className="ml-2 w-5 h-5" />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;